export const DASHBOARD = {
  bg: "#FDFBF2",
  card: "#FFFFFF",
  header: "#345952",
  textMuted: "#8A8A85",
  textDark: "#4A4A48",
  grid: "#E8E8E4",

  purple: "#9C93C5",
  lightPurple: "#BAB3D6",
  teal: "#93B9AD",
  terracotta: "#D38C74",
  darkTeal: "#436A63",
  internalLive: "#7BA3C9",
  internalRd: "#C9A27B",

  casesCredited: "#A096C9",
  totalUnits: "#95B8B0",
  designUnitsCard: "#D18E79",
  qcUnitsCard: "#3C615D",
} as const;

export type DashboardView = {
  empName: string;
  role: string;
  shift: string;
  casesCredited: number;
  totalUnits: number;
  designEfficiency: number;
  designUnits: number;
  designPerDay: number;
  qcEfficiency: number;
  qcCases: number;
  qcUnits: number;
  redesignEfficiency: number;
  redesignCases: number;
  redesignUnits: number;
  mixDesign: number;
  mixQc: number;
  mixRedesign: number;
  unitsDay: number;
  unitsWeek: number;
  unitsMonth: number;
  reworkClean: number;
  reworkReturned: number;
  liveVolume: number;
  redesignVolume: number;
  designUnitsLive: number;
  qcUnitsLive: number;
  designUnitsRedesign: number;
  qcUnitsRedesign: number;
  designUnitsInternalLive: number;
  qcUnitsInternalLive: number;
  designUnitsInternalRedesign: number;
  qcUnitsInternalRedesign: number;
  pipelineTotal: number;
  pipelineDesign: number;
  pipelineQc: number;
  pipelineDelivered: number;
  pipelineBranchUnits: number;
  pipelineBranchCases: number;
  casesCapacity: {
    casesCredited: number;
    qcCases: number;
    totalUnits: number;
    designUnits: number;
    qcUnits: number;
    capacity: number;
    dailyCapacity: number;
    workDays: number;
  };
};
